import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import toggleFiltersOpen from "@insite/client-framework/Store/Pages/InvoiceHistory/Handlers/ToggleFiltersOpen";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Filter from "@insite/mobius/Icons/Filter";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import MyAccountFilterButton from "@stoneage/App/Components/MyAccount/MyAccountFilterButton";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapDispatchToProps = {
    toggleFiltersOpen,
};

type Props = ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface InvoiceHistoryHeaderStyles {
    toggleFilterWrapper?: InjectableCss;
}

export const headerStyles: InvoiceHistoryHeaderStyles = {
    toggleFilterWrapper: {
        css: css`
            padding-bottom: 20px;
            display: flex;
            justify-content: flex-start;
        `,
    },
};
const styles = headerStyles;

const InvoiceHistoryHeader: FC<Props> = ({ toggleFiltersOpen, id }) => {
    return (
        <StyledWrapper {...styles.toggleFilterWrapper}>
            <MyAccountFilterButton toggleFiltersOpen={toggleFiltersOpen} />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(null, mapDispatchToProps)(InvoiceHistoryHeader),
    definition: {
        group: "Invoice History",
        displayName: "Filter Button",
        allowedContexts: ["InvoiceHistoryPage"],
    },
};

export default widgetModule;
